import { render, staticRenderFns } from "./AssetSummary.vue?vue&type=template&id=1c01c4b6&scoped=true"
import script from "./AssetSummary.vue?vue&type=script&lang=js"
export * from "./AssetSummary.vue?vue&type=script&lang=js"
import style0 from "./AssetSummary.vue?vue&type=style&index=0&id=1c01c4b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01c4b6",
  null
  
)

export default component.exports